export default __webpack_public_path__ + "static/media/main_excellence_picture.bd5ca596.png";